import { Howl } from "howler";
import { api } from "./api";

let sfxCache = {}; // gameId -> assets[]

export async function loadSfxAssets(gameId, force = false) {
  if (sfxCache[gameId] && !force) return sfxCache[gameId];
  const { data } = await api.get("/uploads", { params: { game_id: gameId, kind: "sfx" } });
  sfxCache[gameId] = data;
  return data;
}

export function invalidateSfxCache(gameId) {
  delete sfxCache[gameId];
}

export function assetUrl(assetId) {
  return `${api.defaults.baseURL}/uploads/${assetId}`;
}

export function playSfxAsset(assetId) {
  if (!assetId) return;
  const howl = new Howl({ src: [assetUrl(assetId)], volume: getLocalVolume() });
  howl.play();
}

// Subtle 2-tone chime for "it's your turn" — synthesized client-side via Web Audio so it works
// instantly for every player regardless of what SFX assets a GM has (or hasn't) uploaded.
export function playNotificationChime() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const now = ctx.currentTime;
    const vol = getLocalVolume() * 0.35;
    [880, 1320].forEach((freq, i) => {
      const start = now + i * 0.14;
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0, start);
      gain.gain.linearRampToValueAtTime(vol, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.001, start + 0.32);
      osc.connect(gain).connect(ctx.destination);
      osc.start(start);
      osc.stop(start + 0.34);
    });
  } catch {}
}

export async function playSfxByTag(gameId, tag) {
  if (!tag) return;
  try {
    const assets = await loadSfxAssets(gameId);
    const matches = assets.filter((a) => (a.tag || "").toLowerCase() === tag.toLowerCase());
    const match = matches.find((a) => a.is_default) || matches[0];
    if (match) playSfxAsset(match.id);
  } catch {}
}

// Tier 1: player-specific override asset. Tier 2/3: GM's generic tag-based fallback.
export async function triggerSound(gameId, { tag, overrideAssetId } = {}) {
  if (overrideAssetId) {
    playSfxAsset(overrideAssetId);
    return;
  }
  await playSfxByTag(gameId, tag);
}

export function getLocalVolume() {
  const v = parseFloat(localStorage.getItem("ctarms_local_volume"));
  return Number.isFinite(v) ? v : 0.7;
}

export function setLocalVolume(v) {
  localStorage.setItem("ctarms_local_volume", String(v));
}
